import "../scripts/productsPage/chart";
import "../scripts/productsPage/products";
import "../scripts/productsPage/studio";

